module.exports = angular.module('msi.utils', []).name;

angular.module(module.exports)
  .constant('caseConversionService', require('./case-conversion.service'))
  .factory('apiCacheService', require('./api-cache-service'))
  .factory('apiService', require('./api.service'))
  .filter('ogDate', require('./date-filter'));
